import { useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { TypeAnimation } from "react-type-animation";
import { AuthContext } from "../../../contexts/AuthProvider";
import Loading from "../../Shared/Loading/Loading";

const MyBuyers = () => {
  const { user } = useContext(AuthContext);

  const {
    data: bookings = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["bookings"],
    queryFn: async () => {
      const res = await fetch("https://recycle-hut-server.vercel.app/bookings");
      const data = await res.json();
      return data;
    },
  });

  const myBuyers = bookings.filter(
    (booking) => booking.sellerEmail === user?.email
  );
  refetch();

  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <div className="p-5 md:p-8" data-aos="fade-right" data-aos-duration="1500">
      {myBuyers?.length === 0 ? (
        <h3 className="text-red-500 font-bold text-[20px] mt-10 flex justify-center items-center w-[90%] mx-auto h-[60vh] md:h-[75vh] text-center">
          <TypeAnimation
            sequence={["Currently You have no Buyer(s)! ", 3000]}
            speed={60}
            cursor={false}
            repeat={Infinity}
          />
        </h3>
      ) : (
        <>
          <h2 className="text-[22px] md:text-[26px] mb-4 lg:mb-5 text-blue-700 font-bold mt-[-20px] md:mt-[-25px] lg:mt-[-11px] opacity-80 my-transition-4">
            <TypeAnimation
              sequence={["My Buyers Info", 3000]}
              speed={50}
              cursor={false}
              repeat={Infinity}
            />
          </h2>

          <div className="xl:hidden mb-[15px] mt-[-11px] text-green-600 font-semibold">
            <small>
              <TypeAnimation
                sequence={[
                  `Please! Scroll  Right side to see more Table Columns..`,
                  3000,
                ]}
                speed={70}
                cursor={true}
                repeat={Infinity}
              />
            </small>
          </div>

          <div className="overflow-x-auto shadow-xl rounded-lg uncommon">
            <table className="table w-full">
              <thead>
                <tr>
                  <th>Buyer Full Name</th>
                  <th>Phone Booked</th>
                  <th>Image</th>
                  <th>Buyer Email Address</th>
                  <th>Contact Number</th>
                  <th>Buyer Location</th>
                </tr>
              </thead>
              <tbody>
                {myBuyers.map((myBuyer, i) => (
                  <tr key={myBuyer._id} className="hover">
                    <td>{myBuyer.buyerName}</td>
                    <td>{myBuyer.mobileName}</td>
                    <td>
                      <PhotoProvider
                        speed={() => 800}
                        easing={(type) =>
                          type === 2
                            ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                            : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                        }
                      >
                        <PhotoView src={myBuyer.img}>
                          <figure>
                            <LazyLoadImage
                              src={myBuyer.img}
                              alt={myBuyer.mobileName}
                              width="50px"
                              placeholderSrc={myBuyer.img}
                              effect="blur"
                              title={myBuyer.mobileName}
                              style={{ objectFit: "cover", cursor: "pointer" }}
                            />
                          </figure>
                        </PhotoView>
                      </PhotoProvider>
                    </td>
                    <td>{myBuyer.buyerEmail}</td>
                    <td>{myBuyer.buyerMobile}</td>
                    <td>{myBuyer.meetLocation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default MyBuyers;
